// extracted by mini-css-extract-plugin
module.exports = {"podcastembed":"applepodcastembed-module--podcastembed--3Kpgs","container":"applepodcastembed-module--container--3dKwl"};